var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReinstatePolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 4.66667C9.16667 6.50833 7.675 8 5.83333 8C3.99167 8 2.5 6.50833 2.5 4.66667C2.5 2.825 3.99167 1.33333 5.83333 1.33333C7.675 1.33333 9.16667 2.825 9.16667 4.66667ZM9.16667 10.2667V14.6667H0V13C0 11.1583 2.60833 9.66667 5.83333 9.66667C7.08333 9.66667 8.225 9.89167 9.16667 10.2667ZM20 14.6667H10.8333V0.5H20V14.6667ZM13.3333 7.58333C13.3333 6.43333 14.2667 5.5 15.4167 5.5C16.5667 5.5 17.5 6.43333 17.5 7.58333C17.5 8.73333 16.5667 9.66667 15.4167 9.66667C14.2667 9.66667 13.3333 8.73333 13.3333 7.58333ZM18.3333 3.83333C17.4167 3.83333 16.6667 3.09167 16.6667 2.16667H14.1667C14.1667 3.09167 13.425 3.83333 12.5 3.83333V11.3333C13.425 11.3333 14.1667 12.0833 14.1667 13H16.6667C16.6667 12.0833 17.4167 11.3333 18.3333 11.3333V3.83333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinstatePolicy);
export default __webpack_public_path__ + "static/media/reinstate-policy.3f02099a3b26785ddc4d5fdfda460d42.svg";
export { ForwardRef as ReactComponent };